import { actions as appActions } from 'Data/ReduxViewModels/App';
import { TitleSource } from 'Data/ReduxViewModels/App/types';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

type AppPageComponentProps = {
  /**
   * Defines the generic page title to display for the given page component
   *
   * This is a fixed, general title that may be overridden by the page component at a later point if required (e.g. when title contains data to be retrieved)
   */
  pageTitle?: string;
  /**
   * The page component
   */
  children?: any;
};

/**
 * Wrapper for page components to provide general functionality
 */
const AppPageComponent: React.FC<AppPageComponentProps> = ({ pageTitle, children }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      appActions.setPageTitle({
        pageTitle,
        source: TitleSource.Generic,
      })
    );
    return () => {
      dispatch(
        appActions.setPageTitle({
          pageTitle: undefined,
          source: TitleSource.Generic,
        })
      );
    };
  }, [dispatch, pageTitle]);

  return children;
};

export { AppPageComponent };
export default AppPageComponent;
